import { Injectable, OnDestroy } from '@angular/core';
import { UserProfileService } from '@core/services/user-profile/user-profile.service';
import { UserProfile } from '@shared/model/user-profile.model';
import { BehaviorSubject, Observable, Subject, takeUntil, tap } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class MyAccountStoreService implements OnDestroy {
	#myAccountData: BehaviorSubject<UserProfile> = new BehaviorSubject(null);
	public myAccountData$: Observable<UserProfile> = this.#myAccountData.asObservable();

	private readonly destroy: Subject<void> = new Subject();

	public get myAccountData(): UserProfile {
		return this.#myAccountData.getValue();
	}

	constructor(private readonly userProfileService: UserProfileService) {
		this.userProfileService
			.getProfile()
			.pipe(
				tap((response) => {
					this.#myAccountData.next(response);
				}),
				takeUntil(this.destroy)
			)
			.subscribe();
	}

	public ngOnDestroy(): void {
		this.destroy.next();
		this.destroy.complete();
	}

	public updateProfileData(updatedData: UserProfile): void {
		this.#myAccountData.next(updatedData);
	}
}
